import { MONTHLY_Q_REQUIREMENT_NAME } from "../../services/MonthlyQ/monthlyQ.types";
import { REQUIREMENT_NAME } from "../enums/requirements";

export const QUALIFIED = "QUALIFIED";
export const TRACKING = "TRACKING";
export const GRADUATED = "GRADUATED";
export const DENIED = "DENIED";
export const ELIGIBLE = "ELIGIBLE";
export const PENDING_ELIGIBLE = "PENDING_ELIGIBLE";
export const STARTED = "STARTED";
export const NOT_STARTED = "NOT_STARTED";
export const CURRENT = "current";
export const NEXT = "next";

export const STATUS = {
  QUALIFIED,
  TRACKING,
  DENIED,
  ELIGIBLE,
  PENDING_ELIGIBLE,
};

export const REASON = {
  STARTED,
  NOT_STARTED,
  GRADUATED,
};

export const REQUIREMENT_TYPES = {
  PERCENT: "PERCENT",
  VOLUME: "VOLUME",
  AWARD: "AWARD",
};

export const PPV = {
  requirementType: REQUIREMENT_TYPES.VOLUME,
  requirement: "personal",
  text: "ppv",
};

export const PERFORMANCE_BONUS = {
  requirementType: REQUIREMENT_TYPES.PERCENT,
  requirement: "performanceBonus",
  text: "performanceBonus",
};

export const THREE_LEGS_3_PERCENT = {
  requirementType: REQUIREMENT_TYPES.PERCENT,
  requirement: "3pctLegs",
  text: "threeLegs3",
};

export const THREE_LEGS_6_PERCENT = {
  requirementType: REQUIREMENT_TYPES.PERCENT,
  requirement: "6pctLegs",
  text: "threeLegs6",
};

export const TWO_LEGS_3_PERCENT_WITH_VCS = {
  requirementType: REQUIREMENT_TYPES.AWARD,
  requirement: "basisCheckForBfiVcsSpon/generatorWithEq",
  text: "twoLegs3",
};

export const TWO_LEGS_6_PERCENT_WITH_VCS = {
  requirementType: REQUIREMENT_TYPES.AWARD,
  requirement: "basisCheckForBbiVcsSpon/generatorWithEq",
  text: "twoLegs6",
};

export const VCS_PV = {
  requirementType: REQUIREMENT_TYPES.VOLUME,
  requirement: "vcs",
  text: "vcsPv",
};

export const VCS_PERCENT = {
  requirementType: REQUIREMENT_TYPES.PERCENT,
  requirement: "ratioOfVcsToPpvPersonalOts(100%-OtsPercent(bonusAward552)",
  text: "vcs",
};

export const PCPV = {
  requirementType: REQUIREMENT_TYPES.VOLUME,
  requirement: "personalTransaction",
  text: "pcpv",
};

export const PAPV = {
  requirementType: "VOLUME",
  requirement: "personalActivityPv",
  text: "ppv",
};

export const BRONZE_REQ_ORDER = [
  PPV,
  PCPV,
  PAPV,
  PERFORMANCE_BONUS,
  THREE_LEGS_3_PERCENT,
  THREE_LEGS_6_PERCENT,
  VCS_PV,
  TWO_LEGS_3_PERCENT_WITH_VCS,
  TWO_LEGS_6_PERCENT_WITH_VCS,
  VCS_PERCENT,
];

export type RecName = REQUIREMENT_NAME | MONTHLY_Q_REQUIREMENT_NAME;

export const pinRequirements: RecName[] = [
  REQUIREMENT_NAME.BASIS_PLATINUM,
  REQUIREMENT_NAME.BASIS_FOUNDERS_PLATINUM,
  REQUIREMENT_NAME.BASIS_FOUNDERS_PLATINUM_GE,
  REQUIREMENT_NAME.BASIS_SILVER,
  REQUIREMENT_NAME.CURRENT_AWARD_PLATINUM_GE,
  REQUIREMENT_NAME.BASIS_CHECK_FOR_GOLD_WITH_EQ,
  REQUIREMENT_NAME.BASIS_EMERALD_CHECK_GE,
  REQUIREMENT_NAME.BASIS_EMERALD_EQ,
  REQUIREMENT_NAME.BASIS_FOUNDERS_PLATINUM_EMERALD,
  REQUIREMENT_NAME.BASIS_CHECK_FOR_FOUNDERS_GOLD,
  REQUIREMENT_NAME.BASIS_DIAMOND,
  REQUIREMENT_NAME.BASIS_DIAMOND_GE,
  REQUIREMENT_NAME.DIAMOND_PARTICIPANT_EQ,
  REQUIREMENT_NAME.BASIS_CHECK_FOR_FOUNDERS_EMERALD_LE,
  REQUIREMENT_NAME.FOUNDERS_PLATINUM_RQ_CHECK_GE,
  REQUIREMENT_NAME.FOUNDERS_PLATINUM_FT_CHECK_GE,
  REQUIREMENT_NAME.EMERALD_FT_CHECK_GE,
  REQUIREMENT_NAME.IN_MARKET_FOUNDERS_EMERALD,
  REQUIREMENT_NAME.INMARKET_FOUNDERS_DIAMOND_GE,
  REQUIREMENT_NAME.BASIS_CHECK_FOR_EMERALD_PARTICIPANT_GE,
  REQUIREMENT_NAME.SAPPHIRE_RQ_CHECK_GE,
  REQUIREMENT_NAME.BASIS_FOUNDERS_PLATINUM_EBR,
  REQUIREMENT_NAME.BASIS_CHECK_FOR_EMERALD_WITH_EQ,
  REQUIREMENT_NAME.CURRENT_PY_CURRENT_AWARD_CHECK_EMERALD_USING_LT,
];
